export default () => ({
    list: [],
    amountList: [],
    monthData: [],
})